import React from "react";
import "./loaderStyles.scss";

const ClideLoader = ({ message }) => {
  return (
    <div className="overlay-loader">
      <div className="loader-content">
        <div className="spinner"></div>
        {message && <div className="loader-message">{message}</div>}
      </div>
    </div>
  );
};

export default ClideLoader;
